module.exports = __webpack_public_path__ + "static/media/auth-illustration.1cd65e62.png";